module.exports = __webpack_public_path__ + "static/img/icon_4.7c93c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_4.png
// module id = rCkO
// module chunks = 49